/**! @license RSJ 3D Packer
 * RSJ 3D Packer Web Application
 * (C) Copyright 2021 by RSJ Software GmbH Stockdorf. All rights reserved.
 */

import React, {Component, Fragment} from "react";
import ReactDOM from "react-dom";

import {withTranslation} from "react-i18next";

import {Paper, Toolbar, AppBar, Button, IconButton, Drawer, Typography, Divider} from "@material-ui/core";

import MenuIcon from "@material-ui/icons/Menu";

import {saveAs}  from "file-saver";

import {v4 as uuidv4 } from 'uuid';

import ReactGA from "react-ga";

import clonedeep from "lodash.clonedeep";
import axios from "axios";

import "./language";
import ErrorBoundary from "./errorboundary";
import MainWindow from "./responsive";
import LoginDialog from "./login";
import AboutDialog from "./about";
import LoadDialog from "./load";
import {rsp as sampleRsp} from "./samplersp.json";

class App extends Component{
    constructor(props, context) {

        super(props, context);

        var solver = window.solver;

        if (window.solver == undefined) {
            solver = window.location.origin;
            }

        var trackingCode = window.google_analytics_uacct;

        var state= {
            menuOpen: false,
            loginOpen: false,
            loaderOpen: false,
            aboutOpen: false,
            items: sampleRsp.items,
            containers: sampleRsp.containers,
            risks: sampleRsp.risks,
            solution: sampleRsp.packedItems,
            dspContainers: sampleRsp.usedContainers,
            solver: solver,
            trackingCode: trackingCode,
            simplified: true,
            dangerous: false,
            axis: false,
            viewerUrl: sampleRsp.viewerUrl,
            apiUrl: sampleRsp.apiUrl,
            accessToken: null,
            autoSolve: true,
            solveNeeded: false,
            apiNeeded: false,
            perfectNeeded: false,
            level: "free",
            solveActive: false,
            "summary": ""
            };

        this.state=state;

        if (trackingCode) {
            ReactGA.initialize(trackingCode, {debug: true, gaOptions: {storage: "none", userId: uuidv4()}});
            ReactGA.set({anonimizeIp: true});
            ReactGA.pageview("/3dpacker.html");
            }
        this.axiosInstance = axios.create({timeout: 320000});
        this.abortController = null;

        }

    toggleMenu = () => {
        this.setState({menuOpen: !this.state.menuOpen})
        }

    updateContainers = (newContainers) => {

        for (var i=0; i < newContainers.length; i++) {
            newContainers[i].used="";
            newContainers[i].filled="";
            delete newContainers[i].tableData;
            }

        var newItems = clonedeep(this.state.items);
        for (var i=0; i < newItems.length; i++) {
            newItems[i].remaining="";
            delete newItems[i].tableData;
            }

        this.setState({containers: newContainers, items: newItems}, this.onAutoSolve);
        }

    updateItems = (newItems) => {

        var newContainers = clonedeep(this.state.containers);

         for (var i=0; i < newContainers.length; i++) {
            newContainers[i].used="";
            newContainers[i].filled="";
            delete newContainers[i].tableData;
            }

        for (var i=0; i < newItems.length; i++) {
            newItems[i].remaining="";
            delete newItems[i].tableData;
            }

        this.setState({containers: newContainers, items: newItems}, this.onAutoSolve);
        }

    updateRisks = (newRisks) => {

        var newContainers = clonedeep(this.state.containers);

         for (var i=0; i < newContainers.length; i++) {
            newContainers[i].used="";
            newContainers[i].filled="";
            delete newContainers[i].tableData;
            }
        var newItems = clonedeep(this.state.items);
        for (var i=0; i < newItems.length; i++) {
            newItems[i].remaining="";
            delete newItems[i].tableData;
            }

        this.setState({containers: newContainers, items: newItems, risks: newRisks}, this.onAutoSolve);
        }

    updateSolution = (newSolution) => {

        this.solveActive = false;

        this.setState({
            solution: newSolution.packedItems,
            containers: newSolution.containers,
            items: newSolution.items,
            dspContainers: newSolution.usedContainers,
            viewerUrl: newSolution.viewerUrl,
            apiUrl: newSolution.apiUrl,
            summary: newSolution.summary
            });
        }

    updateShowTime = (newShowTime) => {
        var showTime = document.getElementById("showTime");
        if (showTime) {
            showTime.innerText =  newShowTime;
            }
        }

    onAutoSolve = () => {
        if (this.state.autoSolve) {
            this.onSolve();
            }
        }

    onSolve = () => {
        if (!this.state.accessToken) {
            this.setState({loginOpen:true, solveNeeded: true});
            return
            }

        var startTime = new Date().getTime();
        this.setState({solveNeeded:true, menuOpen: false, solveActive: true, summary: ""});

        var req = {
            containers: this.state.containers,
            items: this.state.items,
            risks: this.state.risks
            };

        var headers = {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.state.accessToken
                    };

        var intervalTimer = window.setInterval(() => {
            var curTime = new Date().getTime();
            this.updateShowTime(Math.floor((curTime - startTime) / 1000));
            }, 1000);

        this.abortController = new AbortController();
        this.axiosInstance.post(this.state.solver+"/solve", req, {headers: headers, signal: this.abortController.signal})
            .then(response => {
                window.clearInterval(intervalTimer);
                var curTime = new Date().getTime();
                this.updateShowTime(((curTime - startTime) / 1000));
                this.setState({solveActive: false});
                this.updateSolution(response.data);
                })
            .catch(error => {
                console.log(error);
                window.clearInterval(intervalTimer);
                var curTime = new Date().getTime();
                this.updateShowTime( "Aborted " + ((curTime - startTime) / 1000));
                this.setState({solveActive: false});
                })

        if (this.state.trackingCode) {
            ReactGA.event({category: "3dpacker", action: "solve"});
            }
        }

    cancelRequest = () => {
        if (this.abortController) {
            this.abortController.abort();
            }
        }

    onSave = () => {
        var save = {
            items: this.state.items,
            containers: this.state.containers,
            risks: this.state.risks,
            solution: this.state.solution,
            dspContainers: this.state.dspContainers,
            viewerUrl: this.state.viewerUrl,
            apiUrl: this.state.apiUrl,
            simplified: this.state.simplified,
            dangerous: this.state.dangerous,
            axis: this.state.axis
            };
        var saveTxt = JSON.stringify(save);
        console.log(saveTxt);
        var blob = new Blob([saveTxt], {type: "application/json;charset=utf-8"});
        saveAs(blob, "3dpack.json");
        this.setState({menuOpen: false});
        }

    onLoad = () => {
        this.setState({loaderOpen: true, menuOpen: false});
        }

    onLoadComplete = (data) => {
        if (data == null) {
            this.setState({loaderOpen: false});
            } else {
            this.setState({loaderOpen: false, ...data});
            }
        }

    onWebsite = (data) => {
        window.location = "/";
        }

    onAbout = () => {
        this.setState({aboutOpen: true, menuOpen: false});
        }

    onAboutComplete = () => {
        this.setState({aboutOpen: false});
        }

    onLogin = () => {
        this.setState({loginOpen: true, menuOpen: false});
        }

    onApi = () => {
        if (!this.state.accessToken) {
            this.setState({loginOpen:true, apiNeeded: true, menuOpen: false});
            return
            }
        this.setState({apiNeeded:false, menuOpen: false});
        window.open(this.state.apiUrl, "3DSolution");
        }

    onPerfect = () => {
        if (!this.state.accessToken) {
            this.setState({loginOpen:true, perfectNeeded: true, menuOpen: false});
            return
            }
        this.setState({perfectNeeded:false, menuOpen: false});
        this.axiosInstance.get(this.state.solver+"/perfect",  {"cache": "no-cache"})
            .then(response => {
               this.updateSolution(response.data);
                });
        }

    onLoginComplete = (data, keepOpen) => {
        this.setState({loginOpen: keepOpen});

        if (data) {
            this.setState({level: data.level});

            if (this.state.solveNeeded) {
                this.onSolve();
               }
            if (this.state.apiNeeded) {
                this.onApi();
                }
            if (this.state.perfectNeeded) {
                this.onPerfect();
                }
            }
        }

    toggleExpert = () => {
        this.setState({simplified: !this.state.simplified, menuOpen: false});
        }

    toggleDangerous = () => {
        this.setState({dangerous: !this.state.dangerous, menuOpen: false});
        }

    toggleAxis = () => {
        this.setState({axis: !this.state.axis, menuOpen: false});
        }

    toggleAutoSolve = () => {
        this.setState({autoSolve: !this.state.autoSolve, menuOpen: false});
        }

    onOff = (flag) => {
        var {t} = this.props;
        if (flag) {
            return t("Off");
            }
        return t("On");
        }

    render = () => {
        const {t, i18n} = this.props;
        var {level} = this.state;

        var noExpert = false;
        var noDangerous = false;
        var noAxis = true;

        switch (level) {
            case "free":
                noExpert = true;
                noDangerous = true;
                break;

            case "basic":
                noExpert = true;
                noDangerous = true;
                break;

            case "standard":
                noDangerous = true;
                break;

            case "pro":
                noAxis = false;
                break;
            }
        //i18n.changeLanguage("de");
        return <ErrorBoundary title="3D Packer">
                <Fragment>
                    <AppBar position="static">
                        <Toolbar>
                            <IconButton color="inherit" aria_label={t("Menu")} onClick={this.toggleMenu}>
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" style={{flexGrow: 1}} color="inherit">{t("RSJ 3D Packer")}</Typography>
                        </Toolbar>
                    </AppBar>
                    <Drawer type="temporary" open={this.state.menuOpen} onClose={this.toggleMenu}>
                        <Button onClick={this.onLoad}>{t("Load")}</Button>
                        <Button onClick={this.onSave}>{t("Save")}</Button>
                        <Divider />
                        <Button onClick={this.toggleExpert} disabled={noExpert}>{t("Expert mode")} {this.onOff(!this.state.simplified)}</Button>
                        <Button onClick={this.toggleDangerous} disabled={noDangerous}>{t("Dangerous goods")}  {this.onOff(this.state.dangerous)}</Button>
                        <Button onClick={this.toggleAxis} disabled={noAxis}>{t("Axis (in Development)")}  {this.onOff(this.state.axis)}</Button>
                        <Button onClick={this.toggleAutoSolve}>{t("Auto solve")}  {this.onOff(this.state.autoSolve)}</Button>
                        <Divider />
                        <Button onClick={this.onPerfect}>{t("Create perfect solvable problem")}</Button>
                        <Button onClick={this.onSolve}>{t("Solve")}</Button>
                        <Divider />
                        <Button onClick={this.onApi}>{t("API Test Page")}</Button>
                        <Divider />
                        <Button onClick={this.onLogin}>{t("Subscription")}</Button>
                        <Divider />
                        <Button onClick={this.onWebsite}>{t("Website")}</Button>
                        <Button onClick={this.onAbout}>{t("About")}</Button>
                    </Drawer>
                    <Paper style={{width: "100%"}}>
                        <ErrorBoundary title="MainWindow">
                            <MainWindow root={this} />
                        </ErrorBoundary>
                    </Paper>

                    <ErrorBoundary title={"Login Dialog"}>
                        <LoginDialog open={this.state.loginOpen} loginComplete={this.onLoginComplete} host={this.state.solver} root={this} silentLogin={true} allowLogout={true}/>
                    </ErrorBoundary>

                    <ErrorBoundary title={"Loader Dialog"}>
                        <LoadDialog open={this.state.loaderOpen} loadComplete={this.onLoadComplete}/>
                    </ErrorBoundary>

                    <ErrorBoundary title={"About Dialog"}>
                        <AboutDialog open={this.state.aboutOpen} aboutComplete={this.onAboutComplete} />
                    </ErrorBoundary>

                </Fragment>
        </ErrorBoundary>;
        }
    }
App = withTranslation() (App);

ReactDOM.render(<App />, document.querySelector("#app"));